// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1TypesPaymentBatchStatusCodePaymentBatchStatusResponse {
    static getAttributeTypeMap() {
        return ClaimV1TypesPaymentBatchStatusCodePaymentBatchStatusResponse.attributeTypeMap;
    }
}
ClaimV1TypesPaymentBatchStatusCodePaymentBatchStatusResponse.discriminator = undefined;
ClaimV1TypesPaymentBatchStatusCodePaymentBatchStatusResponse.additionalProperties = false;
ClaimV1TypesPaymentBatchStatusCodePaymentBatchStatusResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1TypesPaymentBatchStatusCodePaymentBatchStatusResponse.js.map